// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadCrumbs_container__99YP2","arrowIcon":"BreadCrumbs_arrowIcon__DVvJ_"};